import SystemPerformance from '../../components/SystemPerformance/SystemPerformance'

const SystemPerformancePage = () => {
  return <SystemPerformance />
}

export default SystemPerformancePage